import { IWT_THEME } from "@gemini/tokens";

import { createB2CBrand } from "../createB2CBrand";
import { createBrandConfigurationInput } from "../createBrandConfigurationInput";
import { useGoogleOneTap } from "../../../src/components/OverlayOrchestrator/overlays/GoogleOneTap/useGoogleOneTap";

import { customBannerConfig } from "./customBannerConfig";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { config } = require(
  `./${process.env.ENVIRONMENT === "local" ? "dev" : process.env.ENVIRONMENT}.ts`,
);

const brandName = "Immowelt";

export default createB2CBrand(
  createBrandConfigurationInput(config, {
    id: "iwt",
    name: brandName,
    defaultTitle: brandName,
    defaultDescription: brandName,
    theme: IWT_THEME,
    i18n: {
      supportedLanguageTags: ["de-DE"],
      defaultLanguageTag: "de-DE",
    },
    portal: "immowelt.de",
    appBanner: {
      adjust: {
        android: "amh4kvapbcyc",
        ios: "e8r3raneanqg",
      },
      custom: customBannerConfig,
    },
    qualtrics: {
      id: "ZN_2ckDltrd5peAJGt",
      id_url: "QSI_S_ZN_2ckDltrd5peAJGt",
      url: "https://zn2ckdltrd5peajgt-avivgroup.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_2ckDltrd5peAJGt",
    },
    airship: {
      trackingConsentId: "b7qUNUGPaAEgAz",
      pushConsentId: "yQNb4U0iFb2Cbz",
    },
    errorEmailAddress: "support@immowelt.de",
    authentication: {
      cookies: {
        accessToken: "oauth.access.token",
        sessionExpiration: "oauth.access.se",
      },
      googleOneTap: {
        useGoogleOneTap,
      },
    },
    featureFlagging: {
      siteCode: "lrj80dsya2",
    },
  }),
);
